<template>
  <div>
  </div>
</template>

<script>
  export default {
    mounted () 
    {
      // Очистка сессии
      localStorage.token = '';

      // Перенаправление на главную
      this.$router.push({name: 'account/login'});
    },
  }
</script>